module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_7005.78bea534.png";